import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

// Styled component with enhanced smooth fade-in animation
const FadeInContainer = styled.div`
  opacity: ${props => (props.$isVisible ? 1 : 0)};
  transform: translateY(${props => (props.$isVisible ? 0 : '15px')});
  transition: opacity ${props => props.$duration || '1.2s'} cubic-bezier(0.25, 0.1, 0.25, 1), 
              transform ${props => props.$duration || '1.2s'} cubic-bezier(0.25, 0.1, 0.25, 1);
  transition-delay: ${props => props.$delay || '0s'};
  will-change: opacity, transform;
  backface-visibility: hidden; /* Helps with smoother animations */
  perspective: 1000px; /* Helps with smoother animations */
`;

const FadeInSection = ({ children, threshold = 0.05, delay = '0s', duration = '1.2s' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        // When the element enters the viewport
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          // Once it's visible, we can stop observing
          observer.unobserve(domRef.current);
        }
      },
      { threshold }
    );
    
    const currentRef = domRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold]);

  return (
    <FadeInContainer
      ref={domRef}
      $isVisible={isVisible}
      $delay={delay}
      $duration={duration}
    >
      {children}
    </FadeInContainer>
  );
};

export default FadeInSection;
